import {fetchGet, generateEndpoint} from "../utils/request";

export const getUsers = async ({ token }) => {
  const url = `${generateEndpoint('getUsers')}`
  return fetchGet(url, token)
}

export const getUser = async ({ token, id }) => {
  const url = `${generateEndpoint('getUser')}?id=${id}`
  return fetchGet(url, token)
}
